module.exports = __webpack_public_path__ + "static/urvaste-mesi2-babdb4b1e547b328854aa9183b20e4a6.png";